import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBannerSpecial = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Spesial_Banner",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 33.194 33.194",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			id: "Group_109",
			"data-name": "Group 109",
			transform: "translate(0 0)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_142",
				"data-name": "Path 142",
				d: "M32.506,4.844A1.742,1.742,0,0,1,34.35,6.688V32.506a1.742,1.742,0,0,1-1.844,1.844H6.688a1.742,1.742,0,0,1-1.844-1.844V6.688A1.742,1.742,0,0,1,6.688,4.844H32.506m0-1.844H6.688A3.7,3.7,0,0,0,3,6.688V32.506a3.7,3.7,0,0,0,3.688,3.688H32.506a3.7,3.7,0,0,0,3.688-3.688V6.688A3.7,3.7,0,0,0,32.506,3Z",
				transform: "translate(-3 -3)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "Group_110",
			"data-name": "Group 110",
			transform: "translate(15.675 7.377)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_143",
				"data-name": "Path 143",
				d: "M11.5,7V25.441h1.844V7Z",
				transform: "translate(-11.5 -7)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "Group_111",
			"data-name": "Group 111",
			transform: "translate(7.377 15.675)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_144",
				"data-name": "Path 144",
				d: "M25.441,11.5H7v1.844H25.441Z",
				transform: "translate(-7 -11.5)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "Group_112",
			"data-name": "Group 112",
			transform: "translate(9.405 9.405)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_145",
				"data-name": "Path 145",
				d: "M21.193,8.1,8.1,21.193l1.291,1.291L22.484,9.391Z",
				transform: "translate(-8.1 -8.1)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "Group_113",
			"data-name": "Group 113",
			transform: "translate(9.405 9.405)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_146",
				"data-name": "Path 146",
				d: "M22.484,21.193,9.391,8.1,8.1,9.391,21.193,22.484Z",
				transform: "translate(-8.1 -8.1)"
			})
		})
	]
});
export default SvgBannerSpecial;
